import '@salesforce/canvas-js-sdk';

export default window.Sfdc;
